<template>

    <m-edit1/>

    <m-shopping-cart-3 v-bind='{...{"EmptyCartImage":null,"instagram":false,"presenterProp":false,"addressName":false,"codeMeliProp":false,"gradeProp":false,"orientationProp":false,"schoolNameProp":false,"classNameProp":false,"birthdayProp":false,"motherJobProp":false,"fatherJobProp":false,"registerRequestProp":false,"gradeSelectProp":false,"roundTripServiceProp":false,"shiftProp":false,"showWalletChargeProp":true,"showWalletGate":true,"advanceDescriptionInputs":"","advanceDescription":false,"defaultGate":"","enableEditOrder":false},...{}}' :style='""' class="" ></m-shopping-cart-3><m-a v-bind='{...{"href":"{\"name\":\"Home\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-button-903 v-bind='{...{},...{}}' :style='""' class="bg-primary text-white shadow" >
                <template #default>   <m-icon v-bind='{...{"icon":"arrow-return-right"},...{}}' :style='""' class="" ></m-icon><m-p v-bind='{...{},...{}}' :style='"font-size:10px"' class="text-white" >
                <template #default>بازگشت   </template>
                </m-p></template>
                </m-button-903></template>
                </m-a>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mShoppingCart3 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/ShoppingCart3'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mButton903 from '@moeinmdn/miw-alpha-components/src/package/Buttons/Button903'; import mIcon from '@moeinmdn/miw-alpha-components/src/package/Icons/Icon'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P';

export default {
    name: 'HomeView',
    components: {mEdit1, mShoppingCart3,mA,mButton903,mIcon,mP },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
